<template>
    <div>
    <el-drawer
        custom-class="custom-drawer"
        :visible.sync="drawerVisible"
        :close-on-press-escape="false"
        :wrapper-closable="false"
        :show-close="false"
        size="700px"
    >
        <template slot="title">
            <div class="custom-title">
                <div class="title-name">{{ order && order.huan_time ? '已还车信息' : '还车操作' }}</div>
                <i class="el-icon-circle-close close-btn pointer" @click="closeDrawer" />
            </div>
        </template>
        <div class="custom-content">
            <el-form ref="huancheForm" :model="huancheData" label-width="120px">
                <el-form-item label="还车时间" prop="huan_time">
                    <el-date-picker
                        v-model="huancheData.huan_time"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择还车时间"
                        style="width: 100%;"
                    />
                </el-form-item>
                <el-form-item label="车辆照片" prop="huan_car_thumbarr">
                    <image-upload
                        :key="`huanche_cheliang_${uploadRenderKey}`"
                        ref="huancheCheliangUpload"
                        :tipInfo="`上传车辆照片，格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                        :image-list="huancheCheliangDefaultList"
                        :maxNumber="10"
                        @updateImg="onUpdateHuancheCheliangImg"
                    />
                </el-form-item>
                <el-form-item label="交接协议照片" prop="huan_car_jiaojie_thumb">
                    <image-upload
                        :key="`huanche_jiaojie_${uploadRenderKey}`"
                        ref="huancheJiaojieUpload"
                        :tipInfo="`上传交接协议照片，格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                        :image-list="huancheJiaojieDefaultList"
                        :maxNumber="10"
                        @updateImg="onUpdateHuancheJiaojieImg"
                    />
                </el-form-item>


                <el-form-item label="计费说明">
                    <div>预约时长：{{ displayAppointmentDays }} 天</div>
                    <div>免费使用时长：{{ displayFreeDays }} 天</div>
                    <div>超过免费时长后每天收费：￥{{ displayOverdueDailyFee }}</div>
                </el-form-item>
                <el-form-item label="实际使用天数" prop="use_days">
                    <el-input-number
                        v-model="huancheData.use_days"
                        :min="0"
                        :precision="0"
                        placeholder="请输入实际使用天数"
                    />
                </el-form-item>
                <el-form-item label="违章/事故记录">
                    <el-button size="mini" type="primary" @click="openZucheShiguDrawer">
                        新增违章/事故信息
                    </el-button>
                    <div v-if="huancheData.zucheShiguInfoArr.length === 0" style="margin-top: 8px; color: #999;">
                        暂无违章/事故信息
                    </div>
                    <div v-else style="margin-top: 8px;">
                        <div
                            v-for="(item, index) in huancheData.zucheShiguInfoArr"
                            :key="`shigu_${index}`"
                            class="shigu-item"
                        >
                            <div>类型：{{ getShiguTypeText(item.type) }}</div>
                            <div>描述：{{ item.miaoshu || '-' }}</div>
                            <div>图片数：{{ item.thumb_arr && item.thumb_arr.length ? item.thumb_arr.length : 0 }}</div>
                            <div v-if="item.thumb_arr && item.thumb_arr.length" class="shigu-thumb-list">
                                <el-image
                                    v-for="(imgPath, imgIndex) in item.thumb_arr"
                                    :key="`shigu_${index}_img_${imgIndex}`"
                                    :src="toAbsoluteImgUrl(imgPath)"
                                    :preview-src-list="item.thumb_arr.map(path => toAbsoluteImgUrl(path))"
                                    class="shigu-thumb"
                                    fit="cover"
                                />
                            </div>
                            <div>金额：￥{{ formatAmount(item.jine) }}</div>
                            <el-button
                                size="mini"
                                type="text"
                                style="padding: 0;"
                                @click="removeZucheShigu(index)"
                            >
                                删除
                            </el-button>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="预计总扣除" prop="huan_kouchu_jine">
                    <el-input-number
                        v-model="huancheData.huan_kouchu_jine"
                        :min="0"
                        :precision="2"
                        placeholder="请输入预计总扣除"
                    />
                    <el-button
                        size="mini"
                        type="primary"
                        style="margin-left: 8px;"
                        @click="autoCalcKouchu"
                    >
                        自动计算
                    </el-button>
                </el-form-item>
                <!-- <el-form-item label="应退押金">
                    <span>￥{{ displayRefundYajin }}</span>
                </el-form-item> -->
                <el-form-item label="备注" prop="huan_remark">
                    <el-input
                        v-model="huancheData.huan_remark"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入备注"
                    />
                </el-form-item>
            </el-form>
            <div class="fix-fotter">
                <el-button
                    style="min-width: 117px; background: #1067E0; font-size: 16px; border-color: #1067E0;"
                    size="mini"
                    type="primary"
                    @click="submitHuanche"
                >
                    提交
                </el-button>
            </div>
        </div>
    </el-drawer>

    <el-drawer
        custom-class="custom-drawer"
        :visible.sync="zucheShiguDrawerVisible"
        :close-on-press-escape="false"
        :wrapper-closable="false"
        :show-close="false"
        size="600px"
        append-to-body
    >
        <template slot="title">
            <div class="custom-title">
                <div class="title-name">新增违章/事故信息</div>
                <i class="el-icon-circle-close close-btn pointer" @click="closeZucheShiguDrawer" />
            </div>
        </template>
        <div class="custom-content">
            <el-form :model="zucheShiguInfo" label-width="100px">
                <el-form-item label="类型">
                    <el-select v-model="zucheShiguInfo.type" placeholder="请选择类型" style="width: 100%;">
                        <el-option :value="1" label="违章" />
                        <el-option :value="2" label="事故" />
                        <el-option :value="3" label="其他" />
                    </el-select>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input
                        v-model="zucheShiguInfo.miaoshu"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入描述"
                    />
                </el-form-item>
                <el-form-item label="图片">
                    <image-upload
                        :key="`shigu_${shiguUploadRenderKey}`"
                        ref="zucheShiguUpload"
                        :tipInfo="`上传图片，格式为'jpg','jpeg','png','gif'，大小不超过2M`"
                        :image-list="zucheShiguDefaultList"
                        :maxNumber="10"
                        @updateImg="onUpdateZucheShiguImg"
                    />
                </el-form-item>
                <el-form-item label="金额">
                    <el-input-number
                        v-model="zucheShiguInfo.jine"
                        :min="0"
                        :precision="2"
                        placeholder="请输入金额"
                    />
                </el-form-item>
            </el-form>
            <div class="fix-fotter">
                <el-button size="mini" @click="closeZucheShiguDrawer">取消</el-button>
                <el-button
                    style="min-width: 117px; background: #1067E0; font-size: 16px; border-color: #1067E0;"
                    size="mini"
                    type="primary"
                    @click="confirmAddZucheShigu"
                >
                    确定
                </el-button>
            </div>
        </div>
    </el-drawer>
    </div>
</template>

<script>
import { posthuanche, detail } from "@/api/tianzheng/zucheorder";
import ImageUpload from "@/components/Upload/image";

export default {
    name: "HuancheInfo",
    components: {
        ImageUpload,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        order: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            huancheData: {
                id: 0,
                huan_car_thumbarr: [],
                huan_car_jiaojie_thumb: [],
                huan_time: '',
                use_days: 0,
                zucheShiguInfoArr: [],
                huan_kouchu_jine: 0,
                huan_remark: '',
            },
            huancheCheliangDefaultList: '',
            huancheJiaojieDefaultList: '',
            zucheShiguDrawerVisible: false,
            zucheShiguInfo: {
                type: 1,
                miaoshu: '',
                thumb_arr: [],
                jine: 0,
            },
            zucheShiguDefaultList: '',
            orderDetail: null,
            uploadRenderKey: 0,
            shiguUploadRenderKey: 0,
        };
    },
    computed: {
        drawerVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit("update:visible", val);
            },
        },
        appointmentDays() {
            return this.toNumber(this.pickValue(this.orderDetail, this.order, ['appointment_days', 'appointmentDays']), 0);
        },
        freeDays() {
            return this.toNumber(this.pickValue(this.orderDetail, this.order, ['comm_info.mianfeizuche_day', 'comm_info.free_rent_days', 'mianfeizuche_day']), 0);
        },
        overdueDailyFee() {
            return this.toNumber(this.pickValue(this.orderDetail, this.order, ['comm_info.yuqi_tian_jine', 'comm_info.overdue_day_amount', 'yuqi_tian_jine']), 0);
        },
        yajinAmount() {
            return this.toNumber(this.pickValue(this.orderDetail, this.order, ['yajin', 'paid_yajin', 'yishouyajin']), 0);
        },
        overFreeDays() {
            const days = this.toNumber(this.huancheData.use_days, 0);
            return Math.max(days - this.freeDays, 0);
        },
        weizhangTotalAmount() {
            if (!Array.isArray(this.huancheData.zucheShiguInfoArr)) return 0;
            return this.huancheData.zucheShiguInfoArr.reduce((sum, item) => {
                return sum + this.toNumber(item.jine, 0);
            }, 0);
        },
        estimatedDeduction() {
            return this.weizhangTotalAmount + this.overFreeDays * this.overdueDailyFee;
        },
        refundYajin() {
            return this.yajinAmount - this.toNumber(this.huancheData.huan_kouchu_jine, 0);
        },
        displayAppointmentDays() {
            return this.formatInt(this.appointmentDays);
        },
        displayFreeDays() {
            return this.formatInt(this.freeDays);
        },
        displayOverdueDailyFee() {
            return this.formatAmount(this.overdueDailyFee);
        },
        displayEstimatedDeduction() {
            return this.formatAmount(this.estimatedDeduction);
        },
        displayRefundYajin() {
            return this.formatAmount(this.refundYajin);
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.initFromOrder(this.order);
                this.fetchOrderDetail();
            } else {
                this.resetForm();
            }
        },
        order: {
            deep: true,
            handler(val) {
                if (this.visible) {
                    this.initFromOrder(val);
                    this.fetchOrderDetail();
                }
            },
        },
    },
    methods: {
        getCurrentDateTimeString() {
            const date = new Date();
            const pad = (num) => String(num).padStart(2, '0');
            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hour = pad(date.getHours());
            const minute = pad(date.getMinutes());
            const second = pad(date.getSeconds());
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        },
        pickValue(...args) {
            for (let i = 0; i < args.length - 1; i++) {
                const source = args[i];
                if (!source || typeof source !== 'object') continue;
                const keyList = args[args.length - 1];
                for (let j = 0; j < keyList.length; j++) {
                    const key = keyList[j];
                    const value = key.includes('.')
                        ? key.split('.').reduce((acc, cur) => (acc && acc[cur] !== undefined ? acc[cur] : undefined), source)
                        : source[key];
                    if (value !== undefined && value !== null && value !== '') {
                        return value;
                    }
                }
            }
            return '';
        },
        toNumber(value, defaultValue = 0) {
            const num = Number(value);
            return Number.isFinite(num) ? num : defaultValue;
        },
        formatAmount(value) {
            return this.toNumber(value, 0).toFixed(2);
        },
        formatInt(value) {
            return String(parseInt(this.toNumber(value, 0), 10));
        },
        fetchOrderDetail() {
            const id = this.order && this.order.id;
            if (!id) return;
            detail({ id }).then((res) => {
                if (res.code == 200) {
                    this.orderDetail = res.result || null;
                    if (this.orderDetail && this.orderDetail.use_days !== undefined && this.orderDetail.use_days !== null) {
                        this.huancheData.use_days = this.toNumber(this.orderDetail.use_days, this.huancheData.use_days);
                    }
                    this.huancheData.zucheShiguInfoArr = this.parseZucheShiguInfoArr(this.orderDetail);
                    if (this.orderDetail && this.orderDetail.huan_kouchu_jine !== undefined && this.orderDetail.huan_kouchu_jine !== null && this.orderDetail.huan_kouchu_jine !== '') {
                        this.huancheData.huan_kouchu_jine = this.toNumber(this.orderDetail.huan_kouchu_jine, this.huancheData.huan_kouchu_jine);
                    } else if (!this.order || (this.order.huan_kouchu_jine === undefined || this.order.huan_kouchu_jine === null || this.order.huan_kouchu_jine === '')) {
                        this.huancheData.huan_kouchu_jine = this.estimatedDeduction;
                    }
                } else {
                    this.$message.error(res.message || '获取订单详情失败');
                }
            });
        },
        parseImgArray(value) {
            if (!value) return [];
            if (Array.isArray(value)) {
                return value.map(item => {
                    if (typeof item === 'string') return item;
                    return item.path || item.url || '';
                }).filter(Boolean);
            }
            if (typeof value === 'string') {
                const trimmed = value.trim();
                if (!trimmed) return [];
                try {
                    const parsed = JSON.parse(trimmed);
                    if (Array.isArray(parsed)) {
                        return parsed.map(item => {
                            if (typeof item === 'string') return item;
                            return item.path || item.url || '';
                        }).filter(Boolean);
                    }
                } catch (error) {
                    // 非JSON字符串，按逗号分隔兼容历史数据
                }
                return trimmed.split(',').map(item => item.trim()).filter(Boolean);
            }
            return [];
        },
        toAbsoluteImgUrl(path) {
            if (!path) return '';
            if (/^https?:\/\//.test(path)) return path;
            const baseUrl = (this.$publicData && this.$publicData.imgUrl) || '';
            return `${baseUrl}${path}`;
        },
        buildUploadDefaultList(pathArr) {
            if (!Array.isArray(pathArr) || pathArr.length === 0) return '';
            return JSON.stringify(pathArr.map((path, index) => ({
                name: `img_${index + 1}`,
                path,
                url: this.toAbsoluteImgUrl(path),
            })));
        },
        extractUploadPaths(val) {
            if (!Array.isArray(val)) return [];
            return val.map(item => {
                if (item.path) return item.path;
                if (item.response && item.response.result && item.response.result.url) {
                    return item.response.result.url;
                }
                return item.url || '';
            }).filter(Boolean);
        },
        normalizeZucheShiguInfo(item = {}) {
            const type = this.toNumber(item.type, 1);
            return {
                type: [1, 2, 3].includes(type) ? type : 1,
                miaoshu: item.miaoshu || item.weizhang || '',
                thumb_arr: this.parseImgArray(item.thumb_arr || item.weizhang_thumb),
                jine: this.toNumber(item.jine !== undefined ? item.jine : item.weizhang_jine, 0),
            };
        },
        parseZucheShiguInfoArr(source) {
            if (!source || typeof source !== 'object') return [];
            const value = source.zucheShiguInfoArr;
            let arr = [];
            if (Array.isArray(value)) {
                arr = value;
            } else if (typeof value === 'string') {
                const trimmed = value.trim();
                if (trimmed) {
                    try {
                        const parsed = JSON.parse(trimmed);
                        if (Array.isArray(parsed)) {
                            arr = parsed;
                        }
                    } catch (error) {
                        arr = [];
                    }
                }
            }
            if (arr.length > 0) {
                return arr.map(item => this.normalizeZucheShiguInfo(item));
            }

            const legacyDesc = source.weizhang || '';
            const legacyThumb = this.parseImgArray(source.weizhang_thumb);
            const legacyMoney = this.toNumber(source.weizhang_jine, 0);
            if (legacyDesc || legacyThumb.length > 0 || legacyMoney > 0) {
                return [
                    {
                        type: 1,
                        miaoshu: legacyDesc,
                        thumb_arr: legacyThumb,
                        jine: legacyMoney,
                    },
                ];
            }
            return [];
        },
        getShiguTypeText(type) {
            const typeNum = this.toNumber(type, 1);
            if (typeNum === 2) return '事故';
            if (typeNum === 3) return '其他';
            return '违章';
        },
        initFromOrder(order) {
            if (!order) {
                this.resetForm();
                return;
            }
            this.clearMainUploadCache();
            const carThumbArr = this.parseImgArray(order.huan_car_thumbarr);
            const jiaojieThumbArr = this.parseImgArray(order.huan_car_jiaojie_thumb);

            this.huancheData = {
                id: order.id || 0,
                huan_car_thumbarr: carThumbArr,
                huan_car_jiaojie_thumb: jiaojieThumbArr,
                huan_time: order.huan_time || this.getCurrentDateTimeString(),
                use_days: Number(order.use_days || 0),
                zucheShiguInfoArr: this.parseZucheShiguInfoArr(order),
                huan_kouchu_jine: Number(order.huan_kouchu_jine || 0),
                huan_remark: order.huan_remark || '',
            };

            if (!order.huan_kouchu_jine && order.huan_kouchu_jine !== 0) {
                this.huancheData.huan_kouchu_jine = this.estimatedDeduction;
            }

            this.huancheCheliangDefaultList = '';
            this.huancheJiaojieDefaultList = '';
            this.zucheShiguDefaultList = '';

            this.$nextTick(() => {
                this.huancheCheliangDefaultList = this.buildUploadDefaultList(carThumbArr);
                this.huancheJiaojieDefaultList = this.buildUploadDefaultList(jiaojieThumbArr);
            });
        },
        resetForm() {
            this.clearMainUploadCache();
            this.huancheData = {
                id: 0,
                huan_car_thumbarr: [],
                huan_car_jiaojie_thumb: [],
                huan_time: this.getCurrentDateTimeString(),
                use_days: 0,
                zucheShiguInfoArr: [],
                huan_kouchu_jine: 0,
                huan_remark: '',
            };
            this.huancheCheliangDefaultList = '';
            this.huancheJiaojieDefaultList = '';
            this.zucheShiguDrawerVisible = false;
            this.zucheShiguInfo = {
                type: 1,
                miaoshu: '',
                thumb_arr: [],
                jine: 0,
            };
            this.zucheShiguDefaultList = '';
            this.shiguUploadRenderKey += 1;
            this.orderDetail = null;
        },
        clearMainUploadCache() {
            const refs = ['huancheCheliangUpload', 'huancheJiaojieUpload'];
            refs.forEach((name) => {
                const comp = this.$refs[name];
                if (comp && typeof comp.clearFileList === 'function') {
                    comp.clearFileList();
                }
            });
            this.uploadRenderKey += 1;
        },
        closeDrawer() {
            this.drawerVisible = false;
            this.resetForm();
            this.$emit("closed");
        },
        onUpdateHuancheCheliangImg(val) {
            this.huancheData.huan_car_thumbarr = this.extractUploadPaths(val);
        },
        onUpdateHuancheJiaojieImg(val) {
            this.huancheData.huan_car_jiaojie_thumb = this.extractUploadPaths(val);
        },
        onUpdateZucheShiguImg(val) {
            this.zucheShiguInfo.thumb_arr = this.extractUploadPaths(val);
        },
        openZucheShiguDrawer() {
            this.zucheShiguInfo = {
                type: 1,
                miaoshu: '',
                thumb_arr: [],
                jine: 0,
            };
            this.zucheShiguDefaultList = '';
            this.shiguUploadRenderKey += 1;
            this.zucheShiguDrawerVisible = true;
            this.$nextTick(() => {
                if (this.$refs.zucheShiguUpload && this.$refs.zucheShiguUpload.clearFileList) {
                    this.$refs.zucheShiguUpload.clearFileList();
                }
            });
        },
        closeZucheShiguDrawer() {
            this.zucheShiguDrawerVisible = false;
        },
        confirmAddZucheShigu() {
            const item = this.normalizeZucheShiguInfo(this.zucheShiguInfo);
            if (!item.miaoshu && item.thumb_arr.length === 0 && this.toNumber(item.jine, 0) <= 0) {
                this.$message.warning('请至少填写描述、上传图片或填写金额中的一项');
                return;
            }
            this.huancheData.zucheShiguInfoArr.push(item);
            this.zucheShiguDrawerVisible = false;
        },
        removeZucheShigu(index) {
            this.huancheData.zucheShiguInfoArr.splice(index, 1);
        },
        autoCalcKouchu() {
            this.huancheData.huan_kouchu_jine = this.toNumber(this.estimatedDeduction, 0);
        },
        submitHuanche() {
            if (!this.order || !this.order.id) {
                this.$message.warning('订单信息不存在，请刷新后重试');
                return;
            }
            if (this.huancheData.huan_car_thumbarr.length === 0) {
                this.$message.warning('请上传车辆照片');
                return;
            }
            if (this.huancheData.huan_car_jiaojie_thumb.length === 0) {
                this.$message.warning('请上传交接协议照片');
                return;
            }

            const shiguInfoArr = Array.isArray(this.huancheData.zucheShiguInfoArr)
                ? this.huancheData.zucheShiguInfoArr.map(item => this.normalizeZucheShiguInfo(item))
                : [];
            const legacyWeizhangArr = shiguInfoArr.filter(item => this.toNumber(item.type, 1) === 1);
            const legacyWeizhangDesc = legacyWeizhangArr.map(item => item.miaoshu).filter(Boolean).join('；');
            const legacyWeizhangThumb = legacyWeizhangArr.reduce((arr, item) => arr.concat(item.thumb_arr || []), []);
            const legacyWeizhangMoney = shiguInfoArr.reduce((sum, item) => sum + this.toNumber(item.jine, 0), 0);

            const params = {
                id: this.order.id,
                huan_car_thumbarr: JSON.stringify(this.huancheData.huan_car_thumbarr),
                huan_car_jiaojie_thumb: JSON.stringify(this.huancheData.huan_car_jiaojie_thumb),
                huan_time: this.huancheData.huan_time || this.getCurrentDateTimeString(),
                use_days: this.huancheData.use_days,
                zucheShiguInfoArr: shiguInfoArr,
                weizhang: legacyWeizhangDesc,
                weizhang_thumb: JSON.stringify(legacyWeizhangThumb),
                weizhang_jine: legacyWeizhangMoney,
                huan_kouchu_jine: this.huancheData.huan_kouchu_jine,
                huan_remark: this.huancheData.huan_remark,
            };

            posthuanche(params).then((res) => {
                if (res.code == 200) {
                    this.$message.success('还车信息提交成功');
                    this.drawerVisible = false;
                    this.$emit("success");
                    this.$emit("closed");
                    this.resetForm();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
    },
};
</script>

<style scoped>
.shigu-item {
    padding: 8px;
    margin-bottom: 8px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
}

.shigu-thumb-list {
    margin: 4px 0;
}

.shigu-thumb {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    margin-right: 6px;
}
</style>
